class DateUtils {
  // Ex: "22/12/2000" → "2000-12-22"
  static formatDateOec(date) {
    if (!date) return "";

    const partes = date.split("/");

    if (partes.length !== 3) return "";

    const [dia, mes, ano] = partes;

    return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
  }
}

export default DateUtils;
